import React from 'react';

export default ({value = '', label, ...rest}) => (
	<label className='Input'>
		<div className='Input_label'>{label}</div>
		<input value={value} {...rest}/>
	</label>
);